import { render } from "./IconTournamentTypeOfCourt.vue?vue&type=template&id=26a08928&ts=true"
import script from "./IconTournamentTypeOfCourt.vue?vue&type=script&lang=ts"
export * from "./IconTournamentTypeOfCourt.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__